/* eslint-disable max-lines-per-function */
import { store } from "jiffy-store";

import { waitForDOM } from "common/utils/ui/wait_for";
import {
  isCustomizableMadePage,
  isMadeSamplePdp
} from "components/jiffy/product-details/customizable-made-page-utils";

const storeBasePathSelector = "meta[name='store::base_path']";

const pricesCache = new Map();
const inProgressRequests = new Map();

const getCacheKey = (pageMode, madeMode) => `${pageMode}-${madeMode}`;

const loadPrices = (options = {}, callback = null) => {
  const { pageMode = "blanks", madeMode = "print_default" } = options;
  const productId = $('[name="product_id"]').val();
  if (!productId) return;

  const isMadeMode = pageMode === "made";
  const cacheKey = getCacheKey(pageMode, madeMode);

  const getStoreURL = url => {
    const basePathElement = document.querySelector(storeBasePathSelector);
    const storeBasePath = basePathElement ? basePathElement.content : "";
    let printParam = "";
    if (isMadeSamplePdp()) {
      printParam = "?made_sample=true";
    } else if (isCustomizableMadePage()) {
      printParam = "?made_dedicated_pdp=true";
    }

    return storeBasePath + url + printParam;
  };

  const sendRequest = () => {
    if (inProgressRequests.has(cacheKey)) {
      return;
    }

    if (pricesCache.has(cacheKey)) {
      const data = pricesCache.get(cacheKey);
      store.pdp.change({ loadedPrices: data });

      callback && callback();
      return;
    }

    const request = $.ajax({
      type: "GET",
      url: getStoreURL(`/api/products/${productId}/cp`),
      data: {
        made: isMadeMode,
        print: madeMode
      },
      tryCount: 0,
      retryLimit: 3,
      retryDelay: 10_000, // 10 seconds
      error(error) {
        if (error.status === 502 || error.status === 504) {
          this.tryCount += 1;
          if (this.tryCount <= this.retryLimit) {
            // Retry after some time with exponential back-off
            const delay = this.retryDelay * 2 ** (this.tryCount - 1);
            setTimeout(() => {
              $.ajax(this);
            }, delay);
          } else if (error && error.readyState !== 0) {
            inProgressRequests.delete(cacheKey);
          }
        }
      },
      success(data) {
        inProgressRequests.delete(cacheKey);
        pricesCache.set(cacheKey, data);
        const currentCacheKey = getCacheKey("blanks", "print_default");
        if (currentCacheKey === cacheKey) {
          store.pdp.change({ loadedPrices: data });
          callback && callback();
        }
      }
    });
    inProgressRequests.set(cacheKey, request);
  };

  waitForDOM(storeBasePathSelector, sendRequest);
};

export default loadPrices;
